// src/services/relationGoalService.js
import apiClient from "./apiClient";

const endpoints = { base: "/admin/relationGoal" };

// normalize exactly what backend accepts
const normalizeStatus = (s) =>
  String(s || "").toLowerCase() === "publish" ? "Publish" : "UnPublish";

// GET: /admin/relationGoal
export async function getAllRelationGoals({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data; // { statusCode, success, message, data: [...] }
}

// POST (JSON): /admin/relationGoal
export async function addRelationGoal(
  { title, subtitle = "", status },
  { signal } = {}
) {
  const payload = {
    title: String(title || "").trim(),
    subtitle: String(subtitle || "").trim(),
    status: normalizeStatus(status),
  };
  const res = await apiClient.post(endpoints.base, payload, { signal });
  return res.data;
}

// PUT (partial JSON): /admin/relationGoal
export async function updateRelationGoalPartial(
  { id, title, subtitle, status },
  { signal } = {}
) {
  const body = { id };
  if (typeof title !== "undefined") body.title = String(title).trim();
  if (typeof subtitle !== "undefined") body.subtitle = String(subtitle).trim();
  if (typeof status !== "undefined") body.status = normalizeStatus(status);

  const res = await apiClient.put(endpoints.base, body, { signal });
  return res.data;
}

// DELETE (JSON body): /admin/relationGoal
export async function deleteRelationGoal({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, { signal, data: { id } });
  return res.data;
}
